import type { Category } from '@/types/news';
import { createSlug } from '@/utils/slug';

export const categories: Category[] = [
  'Policiales',
  'Política',
  'Sociedad',
  'Economía',
  'Deportes',
  'Cultura',
  'Opinión',
  'Salud',
  'Educación',
  'Tecnología',
  'Internacionales'
];

const descriptions: Record<Category, string> = {
  Policiales: 'Hechos policiales, seguridad y alertas comunitarias.',
  Política: 'Gestion local, Concejo, provincia y decisiones publicas.',
  Sociedad: 'Historias urbanas, servicios, convivencia y comunidad.',
  Economía: 'Comercio, empleo, produccion y consumo regional.',
  Deportes: 'Clubes, competencias, calendario y protagonistas.',
  Cultura: 'Agenda cultural, artistas, patrimonio y escenas locales.',
  Opinión: 'Lecturas editoriales, columnas y voces invitadas.',
  Salud: 'Hospital, prevencion, campanas y bienestar.',
  Educación: 'Escuelas, estudiantes, universidades y formacion.',
  Tecnología: 'Innovacion, conectividad, ciencia y herramientas digitales.',
  Internacionales: 'Noticias globales con impacto o interes local.'
};

export const categoryMetadata = categories.map((name) => ({
  name,
  slug: createSlug(name),
  description: descriptions[name]
}));

export function getCategoryBySlug(slug: string) {
  return categoryMetadata.find((category) => category.slug === slug);
}
